import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useHomeContext } from "../../context/Home_context";
import EditionHero from "../../Components/edition/editionhero/EditionHero";
import EditionAbout from "../../Components/edition/editionabout/EditionAbout";
import EditionStatistics from "../../Components/edition/editionstatistics/EditionStatistics";
import EditionFocusSector from "../../Components/edition/editionfocussector/EditionFocusSector";
import EditionVideo from "../../Components/edition/editionvideo/EditionVideo";
import EditionSpeakers from "../../Components/edition/editionspeakers/EditionSpeakers";
import EditionOurPartner from "../../Components/edition/editionourpartner/EditionOurPartner";
import Loader from "../../Common/loader/Loader";

const Edition = () => {
  const { id } = useParams();
  const { edition_expo_loading, edition_expo_data, GetEditionExpo } =
    useHomeContext();

  useEffect(() => {
    if (GetEditionExpo && id) {
      GetEditionExpo(id);
    }
  }, [id]); // eslint-disable-line

  const isEditionLoading =
    edition_expo_loading ||
    !edition_expo_data ||
    Object.keys(edition_expo_data).length === 0;

  return (
    <>
      <Helmet>
        <title>Edition | Bharat Buildcon</title>
      </Helmet>
      {isEditionLoading ? (
        <Loader fullScreen={true} text="Loading Bharat Buildcon..." />
      ) : (
        <>
          <EditionHero />
          <EditionAbout />
          <EditionStatistics />
          <EditionFocusSector />
          <EditionVideo />
          <EditionSpeakers />
          <EditionOurPartner />
        </>
      )}
    </>
  );
};

export default Edition;
